import { useRouter } from 'next/router'
import { useEffect } from 'react'

// Paths should start with / such as /dashboard, /hardware, etc
// If not, protect against script injection and reject JS input
export const validatePath = (path: string): boolean => {
  if (path.startsWith('/') && !path.includes('javascript:')) {
    // enforce the path starts with '/' followed by any number of letters
    const regex = /^\/[a-zA-Z].*$/
    return regex.test(path)
  }
  return false
}

// Use this hook if a component should not `return_to`
export const useValidateReturnTo = () => {
  const router = useRouter()

  useEffect(() => {
    if (
      router.query?.return_to &&
      typeof router.query?.return_to === 'string'
    ) {
      const returnToIsValid = validatePath(router.query?.return_to as string)
      if (returnToIsValid === false) {
        // Replace with a URL stripped of any params
        console.warn('This is not a valid `return_to` param. Stripping URL...')
        router.replace(window.location.pathname)
      }
    }
  }, [router])
}
